import { getFreeSpinConfig, getPaymentMethod } from '../components/createbonusnew/createbonusnewslice'
import { deleteKycReport } from '../components/KYCDocuments/KycDocSlice'
import { getBaseUrl } from './helper'
var endPoint = process.env.REACT_APP_UPS_API_URL
var apsEndPoint = process.env.REACT_APP_APS_API_URL || (endPoint ? endPoint.replace('/ups/', '/player/') : endPoint)
var devBonusPoint = process.env.REACT_APP_PBS_API_URL
var cyrusEndPoint = process.env.REACT_APP_CYRUS
var biReportLink = process.env.REACT_APP_BIREPORT_LINK
var pnsEndPoint = process.env.REACT_APP_PNS_API_URL
var promoEnginePoint = process.env.REACT_APP_PROMO_API_URL
var loyaltyPoint = process.env.REACT_APP_LOYALTY_API_URL
let baseUrl = ''

export const setBaseUrl = () => {
  baseUrl = getBaseUrl(cyrusEndPoint, endPoint)
}
export const playerapi = {
  getPlayer: endPoint + 'player',
  getPlayerSearch: endPoint + 'player/search',
  getGeneralDetail: endPoint + 'player/',
  // Customer page section summaries: section = account | bets | financials | risk
  getPlayerSectionSummary: (userId, section, currency) =>
    endPoint + `player/${userId}/summary/${section}` + (currency ? `?currency=${currency}` : ''),
  getLoginHistory: endPoint + 'player/',
  getAddLoginHistory: endPoint + 'player/',
  getPaymentHistory: endPoint + 'player/',
  getAccountHistory: endPoint + 'player/',
  getPlayerBetHistory: endPoint + 'bet/',
  getNewPlayer: endPoint + 'player/newplayersearch',
  // getBetHistory: endPoint + "player/bethistory",
  getPlayerActivity: endPoint + 'player/playeractivity',
  getActivePlayer: endPoint + 'player/activeplayers',
  getAddNotes: endPoint + 'player/',
  getNotes: endPoint + 'player/notes',
  getMakeManual: endPoint + 'player/',
  getUpdatePlayer: endPoint + 'player/',
  getBonuswidget: endPoint + 'player/',
  addTags: endPoint + 'player/',
  fraudScrub: (userId) => `${endPoint}player/fraud/${userId}`,
  fraudScrubIp: (ip) => `${endPoint}player/fraud/${ip}/players/`,
  getNotifications: `${endPoint}player/payments/count`,
  getActivateDeactivate: (id) => endPoint + `player/${id}`,
  getUserStakePreference: (id) => endPoint + `player/${id}/stake/preference`,
  saveUserStake: (id) => endPoint + `player/${id}/stake/preference`,
  playerReferral: endPoint + "admin/report/referral",
  getRegistrationTicker: (pageNum, itemPerPage) => endPoint + `player/registration/ticker?pageNumber=${pageNum}&itemsPerPage=${itemPerPage}`,
  getTags: endPoint + `/platformtag/old/get/allTags`,
  kycDocuments: (userId, pageNum, itemsPerPage) => endPoint + `kyc/${userId}?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`,
  deleteKycReport: (id) => endPoint + `kyc/delete/doc/${id}`,
  newPlayerTagType: (tagType) => endPoint + `platformtag/old/get/allTags/by/tagType?tagType=${tagType}`,
  editNotes: endPoint + `/player/`,
  deleteNotes: endPoint + `/player/`,
  updateStakeFactor: endPoint + `player/update/stake-factor`,
  getVIPLevels: endPoint + `platformtag/old/vip/tag/list`,
  assignVIPTag: (customTagId, playerId) => endPoint + `player/assign/vip/tag?customTagId=${customTagId}&playerId=${playerId}`,
  getUserAllTags: (userId) => endPoint + `player/${userId}/all-tags`,
  getPlayerInsights: (userId) => endPoint + `player/${userId}/insights`,
}
export const dashboardApi = () => {
  return {
    getLoosers: baseUrl + 'dashboard/loosers',
    getTurnover: baseUrl + 'dashboard/turnover',
    getWinner: baseUrl + 'dashboard/winners',
    getProfitSports: baseUrl + 'dashboard/profitsports',
    getRevenuBrand: baseUrl + 'dashboard/stakerevenue',
    getRevenuSport: baseUrl + 'dashboard/sportsrevenue',
    getPreMatchTurnover: baseUrl + 'dashboard/turnoverprematch',
    getInplayTurnover: baseUrl + 'dashboard/turnoverinplay',
    getTurnoverMain: baseUrl + 'dashboard/turnovermain',
    getHighestTurnover: baseUrl + 'dashboard/highturnoversports',
    getRevenueBySport: baseUrl + 'dashboard/revenuesports',
  }
}

export const playerapicountry = {
  getPaymentTicker: endPoint + 'wallet/getAllTransactions',
}

export const loginapi = {
  getLogin: endPoint + 'platform/user/login',
}

export const bonusApi = {
  getBonus: devBonusPoint + 'bonus/create',
  getBonusummery: devBonusPoint + 'bonus/all',
  updateBonus: devBonusPoint + 'bonus/update',
  getPlayerBonus: devBonusPoint + 'bonus/',
  updateBonusCode: devBonusPoint + 'bonus/allocate',
  segmentedBonus: devBonusPoint + "bonus/allocate/segmentation",
  getBonuswidget: devBonusPoint + 'bonus/',
  getSystemBonus: (from) => devBonusPoint + `bonus/system/summary?day=${from}`,
  fetchAllBonus: (data) =>
    devBonusPoint +
    `bonus/all?bonusType=${data.bonusType}&bonusStatus=${data.statusType}&pageNumber=${data.pageNumber}&itemsPerPage=${data.itemsPerPage}`,
  getBonusData: (data) =>
    devBonusPoint +
    `bonus/all?pageNumber=${data.pageNumber}&itemsPerPage=${data.itemsPerPage}`,
  fetchSports: devBonusPoint + 'bonus/sports',
  bulkUpload: devBonusPoint + 'bonus/allocatebulk',

  MultibetConfig: devBonusPoint + 'multibet',
  MultibetAccount: devBonusPoint + 'multibet/transactions',
  getCouponCode: devBonusPoint + 'bonus/couponcode',
  getCouponCode: devBonusPoint + 'bonus/couponcode',
  getWithdrawBonus: devBonusPoint + 'bonus/withdraw',
  bonusTicker: devBonusPoint + 'bonus/bonus-ticker',
  allowTax: devBonusPoint + 'bonus/getTags',
  getFreeSpinConfig: (id) => devBonusPoint + `free-spin/${id}/config`,
  getUserFreeSpinConfig: devBonusPoint + 'free-spin',
  providerName: (provider, applicableTo) => endPoint + `bet/games/byProvider?providerType=${applicableTo}&providerNames=${provider}`,
  bonusAwardDetails: (id, pageNum, itemsPerPage) => devBonusPoint + `bonus/${id}/bonus-awarded?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`,
  getAffiliates: devBonusPoint + 'bonus/affiliates',
  // getPaymentMethod: devBonusPoint + 'bonus/getPaymentMethods',
}
// Promotions engine (promotion-service) — missions/campaigns, lotteries,
// badges, loyalty tier config. Called via apiCallerExt (no UPS auth headers).
export const promotionEngineApi = {
  // campaigns / missions
  createCampaign: promoEnginePoint + 'promotion/v1/create',
  listCampaigns: (f) =>
    promoEnginePoint +
    `promotion/v1/view/all?page=${f.page}&size=${f.size}` +
    (f.missionType ? `&missionType=${encodeURIComponent(f.missionType)}` : '') +
    (f.promotionName ? `&promotionName=${encodeURIComponent(f.promotionName)}` : '') +
    (f.operatorId ? `&operatorId=${encodeURIComponent(f.operatorId)}` : ''),
  updateCampaignStatus: (id, action) =>
    promoEnginePoint + `promotion/v1/update/${id}?action=${encodeURIComponent(action)}`,
  campaignParticipants: (promotionId) =>
    promoEnginePoint + `promotion/v1/promotion/details?promotionId=${promotionId}`,
  tierRewardHistory: (playerId, operatorId) =>
    promoEnginePoint +
    `promotion/v1/tier-reward-history?playerId=${playerId}&operatorId=${operatorId}`,
  reloadCache: promoEnginePoint + 'promotion/v1/reload',
  leaderboardStandings: promoEnginePoint + 'promotion/v1/leaderboard/standings',
  // lotteries
  lotteryList: (status, isRegular) =>
    promoEnginePoint +
    `promotion/v1/api/lottery/configurations/filter?status=${status}&isRegularLottery=${isRegular}`,
  lotteryConfig: (id) => promoEnginePoint + `promotion/v1/api/lottery/configuration/${id}`,
  createLottery: promoEnginePoint + 'promotion/v1/api/lottery/configuration',
  lotteryWinners: (id) => promoEnginePoint + `promotion/v1/api/lottery/winners/${id}`,
  lotteryLeaderboard: (id, top) =>
    promoEnginePoint + `promotion/v1/api/lottery/leaderboard/${id}?top=${top}`,
  grantTickets: promoEnginePoint + 'promotion/v1/api/lottery/tickets/create',
  rescheduleDraws: promoEnginePoint + 'promotion/v1/api/lottery/admin/reschedule-pending-draws',
  reloadLotteryData: promoEnginePoint + 'promotion/v1/api/lottery/reload-lottery-data',
  createReservedLottery: promoEnginePoint + 'promotion/v1/api/tier-config/reserved',
  pauseReservedLottery: promoEnginePoint + 'promotion/v1/api/tier-config/pause-reserved-lottery',
  // badges
  createBadge: promoEnginePoint + 'promotion/v1/badges/create',
  availableBadges: promoEnginePoint + 'promotion/v1/badges/available',
  playerBadges: (userId, brandId) =>
    promoEnginePoint + `promotion/v1/badges/player?userId=${userId}&brandId=${brandId}`,
  badgeRuleStatus: (badgeName, ruleName, isActive) =>
    promoEnginePoint +
    `promotion/v1/badges/rule/status?badgeName=${encodeURIComponent(badgeName)}&ruleName=${encodeURIComponent(ruleName)}&isActive=${isActive}`,
  deleteBadgeRule: (badgeName, ruleName) =>
    promoEnginePoint +
    `promotion/v1/badges/rule?badgeName=${encodeURIComponent(badgeName)}&ruleName=${encodeURIComponent(ruleName)}`,
  // loyalty tier config
  tierConfig: promoEnginePoint + 'promotion/v1/api/tier-config',
  tierConfigList: (operatorId, brandId) =>
    promoEnginePoint +
    `promotion/v1/api/tier-config?operatorId=${encodeURIComponent(operatorId || '')}&brandId=${encodeURIComponent(brandId || '')}`,
  updateTierConfig: (tierId, operatorId, brandId) =>
    promoEnginePoint +
    `promotion/v1/api/tier-config?tierId=${tierId}&operatorId=${encodeURIComponent(operatorId)}&brandId=${encodeURIComponent(brandId)}`,
}

// Loyalty backend (loyalty_application_BE) — coins/levels/staking config,
// player lookups, missions, config ops. /api/* uses HTTP Basic; the GraphQL
// brand-settings surface uses x-api-key. Called via apiCallerExt/graphqlCaller.
export const loyaltyApi = {
  graphql: loyaltyPoint + 'loyalty/brand-settings/graphql',
  settingsMetadata: loyaltyPoint + 'loyalty/getBrandSettingsMetadata',
  settingsHistory: (f) =>
    loyaltyPoint +
    `loyalty/getBrandSettingsHistory?brand=${encodeURIComponent(f.brand || '')}&operatorId=${encodeURIComponent(f.operatorId || '')}` +
    (f.section ? `&section=${encodeURIComponent(f.section)}` : '') +
    `&page=${f.page || 1}&limit=${f.limit || 25}`,
  getUserLoyalty: loyaltyPoint + 'loyalty/getUserLoyalty',
  getStakeTier: loyaltyPoint + 'loyalty/getStakeTier',
  loyaltyHistory: loyaltyPoint + 'loyalty/loyaltyHistory',
  getLeaderboard: (f) =>
    loyaltyPoint +
    `loyalty/getLeaderboard?brand=${encodeURIComponent(f.brand || '')}&operatorId=${encodeURIComponent(f.operatorId || '')}` +
    (f.userId ? `&userId=${encodeURIComponent(f.userId)}` : '') +
    (f.top ? `&top=${f.top}` : ''),
  configs: loyaltyPoint + 'loyalty/loyaltyconfigs',
  configById: (f) =>
    loyaltyPoint +
    `loyalty/getloyaltyconfigsbyId?operatorId=${encodeURIComponent(f.operatorId || '')}&brand=${encodeURIComponent(f.brand || '')}`,
  createMission: loyaltyPoint + 'loyalty/createPromoMissions',
  reports: loyaltyPoint + 'loyalty/reports',
  redemptionList: (page, limit) =>
    loyaltyPoint + `loyalty/redemptionList?page=${page}&limit=${limit}`,
  // backoffice admin surface (Basic auth)
  adminRedemptions: (f) =>
    loyaltyPoint +
    `loyalty/admin/redemptions?pageNumber=${f.pageNumber || 0}&itemsPerPage=${f.itemsPerPage || 25}` +
    (f.operatorId ? `&operatorId=${encodeURIComponent(f.operatorId)}` : ''),
  adminRedemptionUpsert: loyaltyPoint + 'loyalty/admin/redemption',
  adminRedemptionDelete: loyaltyPoint + 'loyalty/admin/redemption/delete',
  adminMissions: loyaltyPoint + 'loyalty/admin/missions',
}

export const brandApi = {
  getBrand: endPoint + 'brand',
  getBrandConfig: endPoint + 'brand/configs',
  getByBrand: ({ brandPaginationPage, brandPaginationPageCount }) =>
    endPoint + `brandkey/all?pageNumber=${brandPaginationPage}&itemsPerPage=${brandPaginationPageCount}`,
  addBrandKey: endPoint + 'brandkey',
  getUpdateKey: (id) => endPoint + `brandkey/${id}`,
  getAllBrand: endPoint + 'brand/all',
  brandStatus: (id, status) => `${endPoint}brand/${id}?status=${status}`,
  getSmsProviderList: endPoint + 'config/details/sms/providers',
  getProviderList: (msgType) => `${endPoint}config/details/providers?messageType=${msgType}`
}
export const paymentSearchApi = {
  getPaymentSearch: endPoint + 'player/payment/history',
  getPaymentTickerData: endPoint + 'player/payment/ticker',
  getPendingWithrawals: endPoint + 'player/withdraw',
  getPendingDeposit: endPoint + 'player/payment/images',
  getUpdateDeposit: endPoint + 'player/payment/image',
  getNewPendingWithrawals: endPoint + 'player/withdrawal',
  fetchPedingWithdrawals: ({ pageNum, noItems }) =>
    endPoint +
    `player/withdrawal/bank?pageNumber=${pageNum}&itemsPerPage=${noItems}`,
  fetchPendingWithdrawalsStatus: ({ status, pageNum, noItems }) =>
    endPoint +
    `player/withdrawal/bank?status=${status}&pageNumber=${pageNum}&itemsPerPage=${noItems}`,
  updateWithdrawal: (id) => endPoint + `player/withdraw/${id}`,
  paymentLimitsUrl: endPoint + 'config/details/payment',
  paymentProviders: endPoint + "player/payment/providers",
  playerPaymentLimit: endPoint + "player/payment/limits/update",
  getUserPaymentLimit: (id) => endPoint + `player/payment/limits/${id}`,
  getEventsListById: (tnxId) => endPoint + `player/payment/${tnxId}`,
  updatePaymnetProviderSts: endPoint + "player/payment/providers/update",
  requeastDepoProof: (tnxId) => endPoint + `player/payment/deposit-proof/request?transactionId=${tnxId}`,
  getDepositProof: endPoint + "player/payment/deposit-proof/list",
  acceptDepoProof: (id, comments) => endPoint + `player/payment/deposit-proof/accept?id=${id}&comments=${comments}`,
  rejectDepoProof: (id, comments) => endPoint + `player/payment/deposit-proof/reject?id=${id}&comments=${comments}`,
  cancelWithdrawa: (txnId) => endPoint + `player/${txnId}/cancel/withdraw`,
  UserCashoutAvailability: endPoint + "player/payment/cashout/update",
  getPaymentMethods: endPoint + "player/payment/providers",
  withdrawPayment: endPoint + 'player/payment/providers/withdraw',
  saveWithdrawPayment: endPoint + 'player/payment/providers/withdraw/update',
}

export const bettingApi = () => {
  return {
    getBettingTicker: baseUrl + 'bet/ticker',
    getBetHistoryApi: baseUrl + 'bet/history',
    betId: baseUrl + 'bet/',
    getBetLiability: endPoint + 'bet/liability',
    getCasinoDropdowns: (type) => endPoint + `bet/extraInfo/type?type=${type}`,
    saveConfig: endPoint + `config/details/stake/configs/create`,
    getConfig: endPoint + `config/details/stake/configs/list`,
    updateConfig: endPoint + `config/details/stake/configs/update`,
    getCasinoGamesSearch: (provider, subProvider, category) => endPoint + `bet/games/search/criteria?providerNames=${provider}&subProviderNames=${subProvider}&categories=${category}`,
    getBetHistoryApiCasino: endPoint + 'casino/bet/history',
    getCasinoRounds: (type) => endPoint + `casino/bet/roundId?roundId=${type}`,
  }
}

export const tagApi = {
  getTag: endPoint + 'tags',
  postTag: endPoint + 'player/',
  getAllUserTags: endPoint + 'platformtag/get/allTags',
  // deactiveTag: (userTagId) => endPoint + `player/update/${userTagId}/status`,
  uplaodAssignTags: endPoint + 'player/assign/tag/bulk',
  activeTags: endPoint + 'player/update/user/tag/status',
}

export const reportApi = {
  getReport: endPoint + 'admin/reports',
  geMultipleDepositReport: endPoint + 'admin/report/deposit',
  referFriend: endPoint + "admin/report/referral",
  getWithdrawReport: endPoint + "admin/report/transaction/withdraw",
  getDepositReport: endPoint + "/admin/report/transaction/deposit",
  getPlaceBetReport: endPoint + "/admin/report/bet/gst",
  liabiltyEventReport: endPoint + "admin/report/liability/event",
  liabiltyMarketReport: endPoint + "admin/report/liability/market",
}

export const kycApi = {
  getKyc: endPoint + 'kyc/',
  getKycType: endPoint + 'kyc/type',
  getKycApproval: endPoint + 'kyc/approve/all',
  getkycRejected: endPoint + 'kyc/reject/all',
  playerKycReject: endPoint + 'kyc/update',
  requestKyc: (id) => endPoint + `kyc/kyc/request/${id}`,
}
export const bankApi = {
  getBank: endPoint + 'player/bank/details/',
  activeBank: endPoint + 'player/bank/details/active/',
  setPrimary: (id) => endPoint + `player/${id}/bank/details/`,
}

export const configApi = {
  getConfig: endPoint + 'config/details',
  getConfigValues: endPoint + 'config/details/values',
}

export const userApi = {
  platformUserProfile: endPoint + 'platform/user/profile',
  getPermission: endPoint + 'role/permissions',
  createPermission: endPoint + 'role/create',
  getRoleList: endPoint + 'role/list',
  getAssignRole: endPoint + 'role/assign',
  getAdminUser: endPoint + 'platform/user/list',
  createUser: endPoint + 'platform/user',
  getAllRoles: (brandId) => endPoint + `platform/user/roles/${brandId}`,
  getUserPermission: endPoint + 'platform/user/permission',
  getPermissionCreate: endPoint + 'role/permission/create',
  getRolePermission: endPoint + 'role/permissions',
  editRole: (id) => endPoint + `role/${id}`,
  createAffiliate: endPoint + 'platform/agent/add',
  getAffiliate: endPoint + 'platform/agent',
  addCampaign: (id) => `${endPoint}platform/agent/campaign/${id}`,
  listCampaign: (id, page, items) =>
    `${endPoint}platform/agent/list/campaign/${id}?pageNumber=${page}&itemsPerPage=${items}`,
  addChannel: (id) => `${endPoint}platform/agent/channel/${id}`,
  listChannels: (page, items) =>
    `${endPoint}platform/agent/channel?pageNumber=${page}&itemsPerPage=${items}`,
  listCapaignURL: (capaignId) =>
    `${endPoint}platform/agent/campaign/urls/${capaignId}`,
  totpDetails: endPoint + 'platform/user/totp',
  totpLogin: endPoint + 'platform/user/login/totp',
  resetPassword: (userId) => endPoint + `platform/user/${userId}/password/reset`,
  forcePasswordChange: endPoint + "platform/user/password/reset/force",
  updateUserDetails: (userId) => `${endPoint}platform/user/${userId}`,
  artworkUpload: endPoint + "platform/agent/documents/affiliate",
  getArtwork: endPoint + `platform/agent/documents/affiliate`,
  getAffSummaryDetail: endPoint + "platform/agent/affiliate/user/details",
  refreshToken: endPoint + "platform/user/refreshToken",
  failedData: endPoint + "dashboardv2/failed-report-by-type",
  markAsPaid: endPoint + "platform/agent/affiliate/vip/payment/mark/as/paid",
}

export const resetPasswordApi = {
  getResetPassword: (id) => endPoint + `player/${id}/password/reset`,
}

export const kycUploadEndPoint = {
  uploadKYC: (idType, kycType, userId) => endPoint + `kyc/upload?idType=${idType}&kycType=${kycType}&userId=${userId}`,
}

export const roleDeleteApi = {
  getRoleDelete: endPoint + 'role/delete',
}
export const betApi = {
  getBetAudit: endPoint + 'bet/',
}

//dev.platform-ups.sportsit-tech.net:443/dashboard/operational?from=THIS_MONTH
export const operationsApi = {
  opTable: (from) => endPoint + `dashboard/operational?from=${from}`,
}

export const clientApi = {
  getClient: endPoint + 'client',
}

export const currencyConversionApi = {
  getCurrency: endPoint + 'currency',
}

export const ResponsibleGamblingApi = {
  updateUserLimits: endPoint + '/player/limits/',
  getPlayertLimit: (playerid) => endPoint + `player/limits/${playerid}`
}

export const riskManagement = {
  getFraudScrubIPs: endPoint + `fraudscrub/ips`,
  getFraudScrubUsersByIP: (ip, pageNum, itemsPerPage) => endPoint + `fraudscrub/${ip}/players/?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`,
  getFraudIPAndMacAddress: (pageNum, itemsPerPage) => endPoint + `fraudscrub/ipAndMacaddress?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`,
  getUsersByIPAndMacAddress: (pageNum, itemsPerPage) => endPoint + `fraudscrub/ipAndMacaddress/players?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`,
  getSyndicateBetting: endPoint + `fraudscrub/syndicateBetting`,
  getPlayerbets: (selectionId, fixtureName, stake, pageNum, itemsPerPage) => endPoint + `fraudscrub/syndicateBetting/${selectionId}/${fixtureName}/${stake}/playerbets?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`,
  arbitageBet: (pageNum, itemsPerPage) => endPoint + `fraudscrub/playersDetailsBySameProfileV1?pageNumber=${pageNum}&itemPerPage=${itemsPerPage}`,
  dupeCids: endPoint + "fraudscrub/playersDetailsBySameProfileV2",
  syndicateBettingV2: endPoint + `fraudscrub/syndicateBettingV2`,
  // Re-applies the stake-tolerance band; V1 matches stake exactly - INT-11556.
  syndicateV2PlayerBets: (selectionId) => endPoint + `fraudscrub/syndicateBettingV2/${encodeURIComponent(selectionId)}/playerbets`,
  syndicateUserAnalysis: (userId) => endPoint + `fraudscrub/syndicateBetting/user/${userId}/analysis`,
  syndicateCombinations: endPoint + `fraudscrub/syndicateBetting/combinations`,
  flagSyndicatePattern: (patternId) => endPoint + `fraudscrub/syndicateBetting/flag/${patternId}`,
  lateBets: endPoint + `fraudscrub/latebets`,
}
export const biReportLinks = {
  revenueReport: biReportLink + "?reportId=ddb11ff3-59d8-4246-9e34-421f3621e7c5&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  ggrMonthlyRevenue: biReportLink + "?reportId=8fe3848e-87a0-4ae1-b198-be85c93f44d6&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  ggrDailyRevenue: biReportLink + "?reportId=2ce838a5-2b89-4b8b-af61-ddeec2a84c54&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  ggrDailyRevGameworx: biReportLink + "?reportId=d7ed9dd7-1a66-47dc-aa47-7b131ec13188&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection02fca194dce0030ebc66",

  sportLeague: biReportLink + "?reportId=b3ee14d1-78d3-49ee-a05d-e5537cfb1806&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection",
  sportEventMarket: biReportLink + "?reportId=b3ee14d1-78d3-49ee-a05d-e5537cfb1806&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  sportMonthlyBetCount: biReportLink + "?reportId=b3ee14d1-78d3-49ee-a05d-e5537cfb1806&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSectione3e1061470c146c12aa3",
  sportDailyBetCount: biReportLink + "?reportId=b3ee14d1-78d3-49ee-a05d-e5537cfb1806&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection4b103f4b52eb56048cb5",
  sportBetfoldDaily: biReportLink + "?reportId=b3ee14d1-78d3-49ee-a05d-e5537cfb1806&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSectionaff473bae699d4ca5bdb",
  sportProfitByEvent: biReportLink + "?reportId=b3ee14d1-78d3-49ee-a05d-e5537cfb1806&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSectionecbd8e8e3c8c473217e6",
  sportBetfoldMonthly: biReportLink + "?reportId=b3ee14d1-78d3-49ee-a05d-e5537cfb1806&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection710a0d1e39b3e27be0d0",
  trailing7DayCashStakes: biReportLink + "?reportId=b3ee14d1-78d3-49ee-a05d-e5537cfb1806&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSectionbb9502bcb76cca8d4cb0",
  cashStakesMarketOverview: biReportLink + "?reportId=b3ee14d1-78d3-49ee-a05d-e5537cfb1806&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection8665576098c60350751a",
  highestProfitLoss: biReportLink + "?reportId=b3ee14d1-78d3-49ee-a05d-e5537cfb1806&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSectiondf80f2e3e605dd9e7910",
  // sportRevenueByMarket: biReportLink + "?reportId=c2e4d197-c5c1-4711-ab25-706a86772c9b&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",

  userDailyBettingChannel: biReportLink + "?reportId=9552867e-3c90-4328-b10f-8020597b10fb&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection",
  userMonthlyBettingChannel: biReportLink + "?reportId=9552867e-3c90-4328-b10f-8020597b10fb&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection649d029d761fe1c0005a",
  userBettingChnlGameworx: biReportLink + "?reportId=9552867e-3c90-4328-b10f-8020597b10fb&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection37730dd0465f0ce9adfc",
  bonusReporting: biReportLink + "?reportId=2322fcac-2ef7-429e-ba81-2a31971039aa&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",

  gamesDailySummary: biReportLink + "?reportId=a401bcf3-3dc6-4cd2-8304-7ac9dbf3a1fa&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  gamesTopCustomers: biReportLink + "?reportId=136bf43d-83a5-4d24-a3e1-09eca54681c7&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection82ffdaf7b881b47d66e5",
  gamesDaily: biReportLink + "?reportId=136bf43d-83a5-4d24-a3e1-09eca54681c7&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection33cb23579320750c4990",
  gamesCustomerBetsDaily: biReportLink + "?reportId=136bf43d-83a5-4d24-a3e1-09eca54681c7&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  gameProviderGGR: biReportLink + "?reportId=a05071d5-308c-402c-929c-edb8f8bb08b7&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",

  // averageDailyDeposit: biReportLink + "?reportId=c2e4d197-c5c1-4711-ab25-706a86772c9b&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection77ff234084d1d55a427e",
  // averageMonthlyDeposit: biReportLink + "?reportId=c2e4d197-c5c1-4711-ab25-706a86772c9b&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSectionaae095cbbedc028c8729",
  userWithdrawableBalanceReport: biReportLink + "?reportId=d1328a64-32cb-476a-8110-27d1b87e315b&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  userCumulativeDepositWithdrawalReport: biReportLink + "?reportId=0328300f-c5a5-4de7-8207-ec37325ebd08&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  weeklyUserAnalysis: biReportLink + "?reportId=fa2dab7e-2920-4374-ae95-cdb62d79ec80&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  correctFlex: biReportLink + "?reportId=6f34a570-3d8e-471b-917c-7a306be1d628&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",

  monthlyStateSales: biReportLink + "?reportId=e591c328-c6db-42a9-bf1c-4498f9fa4ded&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  dailyStateSales: biReportLink + "?reportId=e591c328-c6db-42a9-bf1c-4498f9fa4ded&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection4714c5e357471584e86b",
  staKe10K_NGN: biReportLink + "?reportId=e591c328-c6db-42a9-bf1c-4498f9fa4ded&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSection498aee0b6a2a015e316d",
  topPlayersPreferences: biReportLink + "?reportId=e591c328-c6db-42a9-bf1c-4498f9fa4ded&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033&pageName=ReportSectione1dace89de007c359d98",
  // bettingHistoryReport: biReportLink + "?reportId=0ffd000e-eb78-48c1-8acf-b56918621c7b&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  sportsBettingHistoryReport: biReportLink + "?reportId=286c5cf5-8738-4254-bde6-463e5c6284a7&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  casinoBettingHistoryReport: biReportLink + "?reportId=70a360c2-59d6-4ed6-9f9b-c9cc20ca57b6&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  negamesBettingHistoryReport: biReportLink + "?reportId=513cde08-d3b4-42d6-a709-7da6edd80ec6&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  affiliateReport: biReportLink + "?reportId=9af9f94f-45b1-40d9-98b1-f69c8f746d9f&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  dailyUserAnalysis: biReportLink + "?reportId=c792c7d2-4b6c-4b3c-900e-c1876434a9c8&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  playerSearchReport: biReportLink + '?reportId=454a4274-be7e-49bf-8d48-1c17dfc33c0a&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033',
  freeGamesReport: biReportLink + '?reportId=0bc22b67-8fcb-47f4-8a04-2372f322eb72&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033',
  firstTimeDepositFirstTimeBet: biReportLink + '?reportId=e481fa86-427f-4fd9-981f-e57c2604c921&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033',
  ggrBillingReport: biReportLink + '?reportId=d6241e71-696a-48d4-8654-42da4dee78d0&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033',
  providerWiseGgrBillingReport: biReportLink + '?reportId=fa200575-a9fb-46fe-9dc3-ee50327b22c3&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033'
}

export const biDashboardLink = {
  overViewReport: biReportLink + "?reportId=6b480b52-7e8a-4087-be1a-ce550c672432&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  sportsOverViewReport: biReportLink + "?reportId=21e686d6-adb1-4e84-a6fe-c02f0ca00187&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  revenueOverView: biReportLink + "?reportId=5144e72d-2a57-42f9-8426-1f678f7fd190&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  casinoOverViewReport: biReportLink + "?reportId=0a7a9727-f0f1-48fb-a9eb-24c8b48af89f&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  gamesOverViewReport: biReportLink + "?reportId=7b6443ab-346b-4a24-85bd-efa5b48930d6&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
  registrationsOverViewReport: biReportLink + "?reportId=bcfebe0c-9852-4e7f-97b3-77a6a348fe3a&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033",
}

export const biVipLink = {
  DashboardFasFas: biReportLink + '?reportId=7f265ac8-3fea-4cc6-80b1-a63731b0b0be&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033',
  LoyalityVip: biReportLink + '?reportId=23daba70-b0dc-47e7-b553-62ccc5f09353&autoAuth=true&ctid=c6ce5f7c-8c88-434f-bebb-b8103aeff033',
}

export const browserPushApis = {
  userPushNotificationSubscribe: pnsEndPoint + "astra/user/notifications/push/subscribe",
  userPushNotificationUnSubscribe: pnsEndPoint + "astra/user/notifications/push/unsubscribe"
}

export const communicationApis = {
  getPromotionList: pnsEndPoint + "promotions/list",
  savePromotionDtl: pnsEndPoint + "promotions",
  getNotyTemplateByType: pnsEndPoint + "promotions/notification/templates",
  updateNotyTemplate: pnsEndPoint + "promotions/notification/templates",
  updateWelcomeNotyTemplate: pnsEndPoint + "promotions/notification/templates/welcome",
  editPromotionList: (id) => pnsEndPoint + `promotions/${id}`
}

export const boostedOddsApis = {
  //DDL APIS//
  getAllSportsByBrand: endPoint + 'feed/sports',
  getAllCountriesBySport: (sportsId) => endPoint + `feed/countries?sportsId=${sportsId}`,
  getLeaguesBysportAndCountry: (sportId, countryId) => endPoint + `feed/leagues?sportsId=${sportId}&countryId=${countryId}`,
  getEventsBySportCountryLeague: (sport, country, league) => endPoint + `feed/events?sportsId=${sport}&countryId=${country}&leagueId=${league}`,
  getAllMarketsByEvent: (eventId) => endPoint + `feed/markets?eventId=${eventId}`,
  getSubMarketByMarketEvent: (event, market) => endPoint + `feed/subMarkets?eventId=${event}&marketId=${market}`,
  getOutcomesByMarketOrSubmarket: (event, market) => endPoint + `feed/outComes?eventId=${event}&marketId=${market}`, //url changes handled in slice file
  getOddsByOutcomeId: (event, market) => endPoint + `feed/odds?eventId=${event}&marketId=${market}`,//url changes handled in slice file

  //CREATE UPDATE APIS//
  createBoostedOdds: endPoint + "boostedodds/create",
  getAllBoostedOdds: (pageNum, itemsPerPage) => endPoint + `boostedodds/list/all?pageNumber=${pageNum}&itemsPerPage=${itemsPerPage}`, //TABLE API
  updateBoostedOddsStatus: endPoint + "boostedodds/update/status", //ACTIVE DEACTIVE UPDATE API
  boostedOddsSearchApi: endPoint + "boostedodds/search", //SEARCH API
  viewBoostedOddsUsers: (id) => endPoint + `boostedodds/view/users?boostedOddsId=${id}`
}

export const userWatchListApis = {
  addToUserWatchList: endPoint + "player/watch-list/add", //individual player comment
  getUserWatchList: (pagenum, itemsPerPage) => endPoint + `player/watch-list?pageNumber=${pagenum}&itemPerPage=${itemsPerPage}`, // main watchlist screen
  getActivation: endPoint + "player/update/status",

  //ACTIVITIES FOR WATCHLIST USERS 
  getCommentHistory: (userId, pageNum, itemsPerPage) => endPoint + `player/watch-list/comments/history/${userId}?pageNumber=${pageNum}&itemPerPage=${itemsPerPage}`,
  getWatchUsersActivity: (pageNum, itemsPerPage) => endPoint + `player/watch-list/activities?pageNumber=${pageNum}&itemPerPage=${itemsPerPage}`,
  removeUserWatchList: (userId) => endPoint + `player/watch-list/remove/${userId}`,

  //CREATE WATCHLIST APIS
  addAutomatedWatchlist: endPoint + "player/watch-list/auto/config/add",
  getAutomatedWatchlist: (pageNum, itemsPerPage) => endPoint + `player/watch-list/auto/config?pageNumber=${pageNum}&itemPerPage=${itemsPerPage}`,
  getBetTypes: endPoint + `/player/watch-list/auto/config/betTypes`
}

export const newDashboardApis = {
  getOverallReviewReportByPeriod: endPoint + "dashboardv2/overall/review/report",
  getSportsBetsReport: endPoint + "dashboardv2/sports/bets/report",
  getBetReportByGameType: endPoint + "dashboardv2/bet/reports/by/game/type",
  getBonusReport: endPoint + "dashboardv2/bonus/report",
  getPaymnetReport: endPoint + "dashboardv2/payments/report",
  getUserActivityReport: endPoint + "dashboardv2/user/activity/report",
  getUserActiveTimesReportByType: (type) => endPoint + `dashboardv2/user/active/times/report?type=${type}`,
  getTopTenWithdrawableUsers: endPoint + "dashboardv2/top/withdrawable/balance/users",
  getTopTenWinnerLooser: endPoint + "dashboardv2/top/winners/losers/report",
  getTopSportsGamesReport: endPoint + "dashboardv2/top/sports/games/report",
}

export const dashboardV3Apis = {
  getBetReportByGameTypeV3: endPoint + "dashboardv3/bet/reports/by/game/type",
  getTopTenWinnerLooserV3: endPoint + "dashboardv3/top/winners/losers/report",
  getSportsBetsReportV3: endPoint + "dashboardv3/sports/bets/report",
  getTopTenWithdrawableUsersV3: endPoint + "dashboardv3//top/withdrawable/balance/users",
  getTopSportsGamesReportV3: endPoint + "dashboardv3/top/sports/games/report",
  getUserActivityReportV3: endPoint + "dashboardv3/user/activity/report",
  getPaymnetReportV3: endPoint + "dashboardv3/payments/report",
  getBonusReportV3: endPoint + "dashboardv3/bonus/report",
  getTopTenWinnersInPlayApi: endPoint + "dashboardv3/top/live/winners/sports/report",
  getTop10WinnersSports: endPoint + "dashboardv3/top/winners/sports/report",
  getTop10LosersSports: endPoint + "dashboardv3/top/losers/sports/report",
  getTop10WinnersLosersSports: endPoint + "dashboardv3/top/winners/losers/report",
  getTop10WinnersCasino: endPoint + "dashboardv3/top/winners/casino/report",
  getTop10LosersCasino: endPoint + "dashboardv3/top/losers/casino/report"
}

export const CyrusUIApis = {
  getBetSettlement: endPoint + `cyrus/ui/search/all/bets`,
  viewTransaction: endPoint + `cyrus/ui/bet/transactions`,
  syncBet: endPoint + `cyrus/ui/bet/sync`,
  betDeatils: endPoint + `cyrus/ui/bet/selections`,
  rollBack: endPoint + `cyrus/ui/bet/rollback`,
  manualSettlement: endPoint + `cyrus/ui/bet/manual/settlement`,
  viewBetDetails: endPoint + `cyrus/ui/view/astra/bet/history`,
  viewAstra: endPoint + `cyrus/ui/view/astra/bet/selection`,
  getCompetitionName: (type) => endPoint + `cyrus/ui/get/competition?competitionName=${type}`,
  updateCompetitionStatus: endPoint + `cyrus/ui/update/competition/status`,
}





export const Combisuggestions = {
  createAccumulatorConfig: endPoint + "accumulator/create",
  getAccumulator: (pageNum, itemPerpage) => endPoint + `accumulator/list/all?pageNumber=${pageNum}&itemsPerPage=${itemPerpage}`,
  getConfigByID: (id) => endPoint + `accumulator/config/selections/${id}`,
  configEdit: endPoint + "accumulator/update/status",
  searchConfig: endPoint + 'accumulator/search',
  viewUser: (accumulatorId) => endPoint + `accumulator/view/users?accumulatorId=${accumulatorId}`
}
export const TaxationApis = {
  putSportsDetails: endPoint + 'bet/tax/config/sports',
  getSportsDetails: (type, provider) => {
    let url = `${endPoint}bet/tax/config/sports?type=${type}`;
    if (provider) {
      url += `&provider=${provider}`;
    }
    return url;
  }
}


export const biReportLinksV2 = {
  sportsBettingHistoryReport: (pageNum, itemPerPage) => endPoint + `api/report/view?pageNumber=${pageNum}&itemsPerPage=${itemPerPage}`,
  sportsApi: endPoint + "bet/sports/search/criteria",
  downloadAllReports: (pageNum, itemPerPage) => endPoint + `api/report/view/download?pageNumber=${pageNum}&itemsPerPage=${itemPerPage}`,
  downloadableURLsListAPI: (pattern) => endPoint + `api/report/view/download/list?pattern=${pattern}`,
  downloadZipFile: (key) => endPoint + `api/report/view/download/zip?key=${encodeURIComponent(key)}`
}

export const betDecisionApis = {
  getBetdecisionUserdata: (userId, betId) => endPoint + `betdecision/getuserdata?userId=${userId}&betId=${betId}`,
  getCustomerRiskSummary: (userId) => endPoint + `betdecision/getuserdata?userId=${userId}`,
  getUserLast5Bets: (userId) => endPoint + `betdecision/user/bethistory?userId=${userId}`,
  getCustomOddsList: endPoint + 'betdecision/customodds/list',
  getBetFilters: endPoint + 'bet/filters',
  getReferralListDataAPI: endPoint + 'bet/list?pageNumber=0&itemsPerPage=0',
  getBetDecisionResults: endPoint + 'betdecision/result',
  getBetDecisionExtendTimer: endPoint + 'betdecision/extend-time',
  getDecisionReviewedBy: endPoint + 'betdecision/popup-status',
  getActiveReviewers: endPoint + 'betdecision/active-reviewers',
  getUserActiveSession: endPoint + 'platform/user/active-sessions',
  getReferralHistory: (pageNumber, itemsPerPage) => endPoint + `bet/referral-history?pageNumber=${pageNumber}&itemsPerPage=${itemsPerPage}`,
}

export const logoutApi = {
  logout: endPoint + 'platform/user/logout',
}

export const brandCurenciesListApi = {
  getBrandCurenciesList: endPoint + 'internal/brand/currencies',
}

export const fasfasDashboardAPis = {
  getBetReportByGameTypeV2: endPoint + "dashboardv2/bet/reports/by/game/type",
  getTopTenWinnerLooserV2: endPoint + "dashboardv2/top/winners/losers/report",
  getSportsBetsReportV2: endPoint + "dashboardv2/sports/bets/report",
  getTopTenWithdrawableUsersV2: endPoint + "dashboardv2/top/withdrawable/balance/users",
  getTopSportsGamesReportV2: endPoint + "dashboardv2/top/sports/games/report",
  getUserActivityReportV2: endPoint + "dashboardv2/user/activity/report",
  getPaymnetReportV2: endPoint + "dashboardv2/payments/report",
  getBonusReportV2: endPoint + "dashboardv2/bonus/report",
  getTopTenWinnersInPlayApi: endPoint + "dashboardv2/top/live/winners/sports/report",
  getTop10WinnersSports: endPoint + "dashboardv2/top/winners/sports/report",
  getTop10LosersSports: endPoint + "dashboardv2/top/losers/sports/report",
  getTop10WinnersLosersSports: endPoint + "dashboardv2/top/winners/losers/report",
  getTop10WinnersCasino: endPoint + "dashboardv2/top/winners/casino/report",
  getTop10LosersCasino: endPoint + "dashboardv2/top/losers/casino/report",
};

export const boostedOddsRewardConfigApis = {
  createBoostedOddsRewardConfig: endPoint + "config/boosted-odds-reward", //BOOSTED ODDS CONFIG CREATE API
  getBoostedOddsRewardConfig: (brandId) => endPoint + `config/boosted-odds-reward/${brandId}`, //BOOSTED ODDS CONFIG GET API
  getBoostedOddsRewardHistory: (pageNumber, itemsPerPage) => endPoint + `config/boosted-odds-reward/rewards?pageNumber=${pageNumber}&itemsPerPage=${itemsPerPage}`, //BOOSTED ODDS HISTORY LIST API
  createWidgetConfig: endPoint + "widget/boostedodds/add", //WIDGET CONFIG CREATE API
  getWidgetConfig: endPoint + "widget/boostedodds/get", //WIDGET CONFIG GET API
  deleteWidgetConfig: endPoint + "widget/boostedodds/delete", //WIDGET CONFIG DELETE API
}